import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import i18next from 'i18next'
import Notificator from './../Notificator'

import * as ErrorActions from '../../ducks/error'

class ErrorContainer extends React.Component {
  componentWillUnmount() {
    this.props.errorActions.setError(null)
  }

  render() {
    if (!this.props.errorMessage) {
      return <div />
    }

    return (
      <Notificator type="error">
        <header>{i18next.t(this.props.errorMessage)}</header>
      </Notificator>
    )
  }
}

function mapStateToProps(state) {
  return {
    errorMessage: state.error.get('errorMessage')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    errorActions: bindActionCreators(ErrorActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorContainer)



// WEBPACK FOOTER //
// ./src/components/smart/ErrorContainer.js